<template>
  <footer class="footer has-cards">
    <div class="container">
      <div class="row row-grid justify-content-center">
        <div class="col-lg-12">
          <h3 class="text-right">
            <h5 class="mb-3 font-weight-light">Curso produzido por</h5>
            <img :src="require('@/assets/img/logo/logo.png')" style="width:80%;max-width:400px">
          </h3>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6" style="width:50%">
          <div class="copyright">© {{new Date().getFullYear()}}<a href="https://www.ensinandobitcoin.com.br" target="_blank" rel="noopener" class="text-warning"> Ensinando Bitcoin</a>
          </div>
        </div>
        <div class="col-md-6" style="width:50%">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <a href="mailto:ensinandobitcoin@gmail.com" target="_blank" rel="noopener" class="nav-link">Contato</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>

export default {
   name: 'eb-footer'
};
</script>
<style scoped lang="scss">
</style>
